import { useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectToastState, toastClosed } from 'core/slices/toasts';
import { AppDispatch } from 'core/store';
import './Toaster.css';

export const TOAST_SUCCESS = 'toast-success';
export const TOAST_FAIL = 'toast-fail';

export const Toaster = () => {
  const toastState = useSelector(selectToastState);
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const onClose = useCallback(() => {
    dispatch(toastClosed());
  }, [dispatch]);

  const handleActionClick = useCallback(() => {
    if (toastState.props.navUrl) {
      navigate(toastState.props.navUrl);
    }
  }, [toastState.props.navUrl, navigate]);

  useEffect(() => {
    if (toastState.isOpen) {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(onClose, 6000);
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [toastState.isOpen, onClose]);

  if (!toastState.isOpen) {
    return null;
  }

  const toastClassName = `custom-toast ${
    toastState.props.className || ''
  }`.trim();

  return (
    <div className="custom-toast-wrapper">
      <div className={toastClassName}>
        <div className="custom-toast-content">{toastState.props.text}</div>
        {toastState.props.actionButtonText && (
          <button
            className="custom-toast-action"
            onClick={toastState.props.navUrl ? handleActionClick : undefined}
          >
            {toastState.props.actionButtonText}
          </button>
        )}
        <button className="custom-toast-close" onClick={onClose}>
          ×
        </button>
      </div>
    </div>
  );
};
